import { c as _c } from "react/compiler-runtime";
import Component from './component';
import React from 'react';
import Layout from '../../layout';
import { ViewErrorBoundary } from 'shared/error-boundry';
const ViewWrapper = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Layout><ViewErrorBoundary><Component {...props} /></ViewErrorBoundary></Layout>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default ViewWrapper;